import React from 'react';

import { Container, Left, Right } from './Times.styles';

export const Times = () => (
    <Container>
        <Left />
        <Right />
    </Container>
);
